<template>
  <div class="menu">
    <div class="top">服务支持</div>
    <ul>
      <li
        @click="goPath(index, item)"
        :class="active == index ? 'active' : ''"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        { path: "/fwzc/onlineClass", name: "在线课堂" },
        { path: "/fwzc/tecArticles", name: "技术文章" },
      ],
    };
  },
  props: {
    mebuActive: "",
    active: null,
  },
  methods: {
    goPath(index, item) {
      this.$router.push(item.path);
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  background: url("../../../assets/img13.png") #1f3b6d;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  color: #fff;
}

.active {
  background-color: #476da7;
  color: #d1d1d1;
}

.menu {
  width: 250px;
}

ul {
  li {
    width: 250px;
    line-height: 66px;
    border-bottom: 1px solid #cfcfcf;
    background-color: #fff;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
  }

  li:last-child {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fwzc/menu/index.vue